// RootNavigation.js

import * as React from 'react';

export const navigationRef = React.createRef();

export function navigate(name, params) {
  navigationRef.current?.navigate(name, params);
}


export function getparam(params) {
  navigationRef.current?.getParam(params);
}

export function replace(name, params) {
  navigationRef.current?.replace(name, params);

}
// add other navigation functions that you need and export them